function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
  CXS taken from this PR which fixes media queries ordering:
  https://github.com/cxs-css/cxs/pull/82
*/
var cache = {};
var mqs = 0;
var prefix = 'x';
var rules = [];

var insert = function insert(rule) {
  return rules.push(rule);
};

var hyph = function hyph(s) {
  return s.replace(/[A-Z]|^ms/g, '-$&').toLowerCase();
};

var mx = function mx(rule, media) {
  return media ? "".concat(media, "{").concat(rule, "}") : rule;
};

var rx = function rx(cn, prop, val) {
  return ".".concat(cn, "{").concat(hyph(prop), ":").concat(val, "}");
};

var noAnd = function noAnd(s) {
  return s.replace(/&/g, '');
};

var parse = function parse(obj) {
  var child = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var media = arguments.length > 2 ? arguments[2] : undefined;
  return Object.keys(obj).map(function (key) {
    var val = obj[key];
    if (val === null) return '';

    if (_typeof(val) === 'object') {
      var m2 = /^@/.test(key) ? key : null;
      var c2 = m2 ? child : child + key;
      return parse(val, c2, m2 || media);
    }

    var _key = key + val + child + media; // if (cache[_key]) return cache[_key]


    var className = prefix + rules.length.toString(36);
    insert(mx(rx(className + noAnd(child), key, val), media), !!media);
    cache[_key] = className;
    return className;
  }).join(' ');
};

module.exports = function () {
  for (var _len = arguments.length, styles = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    styles[_key2] = arguments[_key2];
  }

  return styles.map(function (style) {
    return parse(style);
  }).join(' ').trim();
};

module.exports.css = function () {
  return rules.sort().join('');
};

module.exports.reset = function () {
  cache = {};

  while (rules.length) {
    rules.pop();
  }
};

module.exports.prefix = function (val) {
  prefix = val;
};

if (typeof document !== 'undefined') {
  var sheet = document.head.appendChild(document.createElement('style')).sheet;

  insert = function insert(rule, media) {
    rules.push(rule);
    if (media) mqs += 1;
    sheet.insertRule(rule, sheet.cssRules.length - (media ? 0 : mqs));
  };
}